<!-- @if (branches.length == 0) {
  <div class="text-center">
    <i class="fa-solid fa-ban text-[#694ed6] text-[4rem] "></i>
    <h1 class="my-3 font-semibold text-3xl text-gray-800">{{ 'translate_branch_not_found' | translate }}</h1>
    <p class="mb-14 text-gray-400">{{ 'translate_no_banches_found' | translate }}</p>
  </div>
  } -->

<div class="m-auto max-w-[61rem] h-[calc(100vh-306px)] md:h-[calc(100vh-274px)] overflow-auto p-3">
  @if (isLoading) {
    <div class="grid gap-4 md:grid-cols-2">
      @for (branch of [1,2,3,4]; track $index) {
        <div class="rounded-2xl bg-white shadow h-max">
          <!-- Header Section -->
          <div class="py-6 px-4 font-semibold border-b border-gray-200">
            <p-skeleton width="10rem" class="mb-2" />
          </div>

          <!-- Content Section -->
          <div class="pt-6 px-4">
            <div class="flex justify-between items-center">
              <div>
                <p-skeleton width="10rem" styleClass="mb-2"/>
                <p-skeleton width="8rem" height="0.75rem"/>
              </div>
              <div class="flex mb-6">
                <p-skeleton width="5rem"/> / <p-skeleton width="2.5rem"/>
              </div>
            </div>
            <div class="flex justify-end">
              <p-skeleton width="7rem" class="mb-2" />
            </div>
          </div>

          <!-- Progress Bar -->
            <p-skeleton width="90%" height="0.25rem" styleClass="my-4 mx-auto" />

          <!-- Footer Section -->
          <div class="flex justify-between items-center pb-4 px-6">
            <p-skeleton width="10rem" class="mb-2" />
            <p-skeleton width="10rem" class="mb-2" />
          </div>
        </div>

      }
    </div>
  }@else {
    <div class="grid gap-4 md:grid-cols-2">
      @for (branch of branches; track $index) {
      <div class="rounded-2xl bg-white shadow h-[max-content]">
        <div class="py-6 px-4 font-semibold border-b border-gray-200 ">
          @if (branch.subscription) {
          <a class="cursor-pointer"
            (click)="router.navigate(['/subscription', 'branches', branch.subscription.subscriptionId])">{{
            branch.name }}</a>
          }@else {
          <p>{{ branch.name }}</p>
          }
        </div>
        @if (branch.subscription) {
        <div class="pt-6 px-4">
          <div class="flex justify-between items-center">
            <div>
              <p class="font-semibold mb-1">{{ branch.subscription.planName}}</p>
              @if (branch.subscription.isTrial) {<p class="text-sm p-color">{{'translate_trial_account' | translate}}</p>}
              @if (branch.subscription.scheduledChange !=null) {
              <p class="text-sm p-color">{{branch.subscription.scheduledChange.title}}</p>
              <p class="text-gray-400 text-xs"> {{ 'translate_scheduled_change' | translate }}
                {{branch.subscription.scheduledChange.downgradeOn | date:'dd/MM/yyyy'}}</p>
              }
            </div>
            <div class="flex mb-6">
              <span class=" text-lg text-gray-600 font-bold">{{branch.subscription.price.amount
                | currency :branch.subscription.price.currency}}</span>
              <span class="text-lg text-gray-400 font-medium">/{{ "translate_" + branch.subscription.price.period
                |translate }}</span>
            </div>
          </div>
          <p class="text-gray-400 text-xs font-medium text-end">
            {{ branch.subscription.userCount }}/{{ branch.subscription.maxUserCount }}{{ "translate_users" | translate}}
          </p>
        </div>
        <!-- -------------------- progress bar ------------------- -->
        <div class="m-4 h-[1px] bg-gray-300">
          <div class="-translate-y-[1px] h-[3px] rounded-full" [style.width]="(branch.subscription.ratio )+'%'"
            [ngClass]="branch.subscription.leftDays > 0 ? 'bg-cyan-300' : 'bg-red-400'"></div>
        </div>
        <!-- ----------------- footer ------------------- -->
        <div class="flex justify-between items-center pb-4 px-6">
          <!-- ----------------- left Days ------------------- -->
          <div>
            @if (branch.subscription.leftDays > 0) {
            <span class="text-gray-400 text-sm font-bold">{{ branch.subscription.leftDays }}</span>
            <span class="text-gray-400 text-xs ms-2">{{ "translate_days_to_restarted" | translate }}</span>
            }
          </div>
          <!-- -------------- action buttons -------------- -->
          @if (branch.subscription.canSubscribe) {
          <a (click)="router.navigate(['/plans'])"
            class="text-primary-700 hover:text-primary-800 text-decoration-none cursor-pointer">
            {{'translate_subscribe_now' | translate}}
            <i class="fa-solid fa-arrow-up ms-1 ltr:rotate-45 rtl:-rotate-45"></i>
          </a>
          }
          @if (branch.billingIds.length>0 && !branch.subscription.isTrial) {
          <a (click)="openPaymentMethodDialog(branch)"
            class="text-primary-700 hover:text-primary-800 cursor-pointer text-decoration-none">
            <span *ngIf="branch.billingCostToPay"> ({{branch.billingCostToPay | currency :
              branch.billingCostCurrency}})</span>
            {{'translate_pay_now' | translate}}
            <i class="fa-solid fa-arrow-up ms-1 ltr:rotate-45 rtl:-rotate-45"></i>
          </a>
          }
          @if (branch.subscription.canUpgradeOrDowngrade) {
          <a (click)="router.navigate(['/subscribe',branch.subscription.subscriptionId])"
            class="text-primary-700 hover:text-primary-800 cursor-pointer text-decoration-none">
            @if (branch.billingCostToPay) {
            <span>({{branch.billingCostToPay | currency : branch.billingCostCurrency}})</span>
            }
            {{'translate_Change_paln' | translate}}
            <i class="fa-solid fa-arrow-up ms-1 ltr:rotate-45 rtl:-rotate-45"></i>
          </a>
          }
        </div>
        }@else {
        <div class="flex pb-4 px-6 register-btn">
          <a (click)="router.navigate(['/plans'])" class="text-primary-700 hover:text-primary-800 text-decoration-none">
            {{'translate_subscribe_now' | translate}}
            <i class="fa-solid fa-arrow-up ms-1 ltr:rotate-45 rtl:-rotate-45"></i>
          </a>
        </div>
        }
      </div>
      }
    </div>
    @if (branches.length==0) {
    <div class="my-5 text-center mx-auto">
      <i class="fa-solid fa-ban text-[#694ed6] text-[3rem] mb-2 block"></i>
      <h1 class="font-semibold text-xl text-gray-800">{{ 'translate_subscribtion_not_found' | translate }}</h1>
    </div>
    }
  }
</div>
